import { ADDITIONAL_COURSE_ID } from "../Constants/courses"

export function isCourseBuilderWorkshop(pyp) {
  return Number(pyp?.navigation?.currentCourseId) === ADDITIONAL_COURSE_ID
}

/** True when course-builder learner is on the last part of the last module. */
export function isCourseBuilderEndOfCourse(pyp) {
  if (!isCourseBuilderWorkshop(pyp)) return false

  const partIds = pyp?.parts?.allIds || []
  const moduleIds = pyp?.modules?.allIds || []
  if (!partIds.length || !moduleIds.length) return false

  const currentPartId = Number(pyp?.navigation?.currentPartId)
  const currentModuleId = Number(pyp?.navigation?.currentModuleId)
  const partIndex = partIds.findIndex((id) => Number(id) === currentPartId)
  const moduleIndex = moduleIds.findIndex((id) => Number(id) === currentModuleId)

  return (
    partIndex >= 0 &&
    moduleIndex >= 0 &&
    partIndex === partIds.length - 1 &&
    moduleIndex === moduleIds.length - 1
  )
}

/**
 * @param {string} moduleTitle
 * @param {{ currentCourseId?: number, currentCourseName?: string }} navigation
 * @param {string} [suffix]
 * @param {number|string|null} [partId] eMpowered only — opens a specific part
 */
export const buildWorkshopLocation = (
  moduleTitle,
  navigation,
  suffix = "",
  partId = null
) => {
  const { currentCourseId, currentCourseName } = navigation || {}
  const pathname = `/workshop/${moduleTitle}${suffix}`
  const useCourseId =
    currentCourseId != null &&
    Number(currentCourseId) === ADDITIONAL_COURSE_ID
  const query = []
  if (useCourseId) {
    query.push(`courseId=${currentCourseId}`)
    if (partId != null && partId !== "" && !Number.isNaN(Number(partId))) {
      query.push(`partId=${Number(partId)}`)
    }
  }
  return {
    pathname,
    search: query.length ? `?${query.join("&")}` : "",
    state: useCourseId
      ? { courseId: currentCourseId, courseName: currentCourseName }
      : { courseName: currentCourseName || "Pursue Your Purpose" }
  }
}
